export const locale = {
    lang: 'es',
    data: {
        NUMBER_HELPER: {
            WRITTEN_NUMBER: {
                OPERATOR: 'y',
                ARS: {
                    INTEGER: {
                        ONE: 'peso',
                        OTHER: 'pesos',
                    },
                    DECIMAL: {
                        ONE: 'centavo',
                        OTHER: 'centavos',
                    },
                },
                BRL: {
                    INTEGER: {
                        ONE: 'real',
                        OTHER: 'reales',
                    },
                    DECIMAL: {
                        ONE: 'centavo',
                        OTHER: 'centavos',
                    },
                },
                EUR: {
                    INTEGER: {
                        ONE: 'euro',
                        OTHER: 'euros',
                    },
                    DECIMAL: {
                        ONE: 'centavo',
                        OTHER: 'centavos',
                    },
                },
                USD: {
                    INTEGER: {
                        ONE: 'dólar',
                        OTHER: 'dólares',
                    },
                    DECIMAL: {
                        ONE: 'centavo',
                        OTHER: 'centavos',
                    },
                },
            },
        },
    },
};
